import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";

import EventRequirements from "./EventRequirements";
import InternalComments from "./InternalComments";

const RequirementsComments = ({ event }) => {
  const requirements = event?.event_requirements ?? [];
  const comments = event?.event_internal_comments ?? [];

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={8}>
        <EventRequirements requirements={requirements} />
      </Grid>

      <Grid item xs={12} md={4}>
        <InternalComments comments={comments} />
      </Grid>
    </Grid>
  );
};

RequirementsComments.propTypes = {
  event: PropTypes.object,
};

RequirementsComments.defaultProps = {
  event: null,
};

export default RequirementsComments;
